module.exports = __webpack_public_path__ + "static/media/logs_unselected.bb0e7757.svg";